import React from 'react';
import Multiselect from 'multiselect-react-dropdown';
import { Field, GenericField, WrappedFieldProps, BaseFieldProps } from 'redux-form';
import { FieldWrapper, FieldWrapperConfig } from './FieldWrapper';
import styles from '../assets/wrapper-input.module.scss';
import classNames from 'classnames';

export type Option = { value: string | number; label: string };

type OwnProps = {
    options: Option[];
    label?: string;
    description?: string;
    placeholder?: string;
    style?: any;
    wrapperConfig?: FieldWrapperConfig;
};

type InputProps = OwnProps & WrappedFieldProps;

const BOOTSTRAP_CONTROL = {
    minHeight: 38,
    padding: '0 .75rem',
    border: '1px solid #ced4da',
    borderRadius: 4,
    fontSize: '1rem',
    lineHeight: 1.5,
    boxShadow: 'none',
    background: '#fff',
};

const MultiSelectInput: React.FC<InputProps> = ({ input, meta, options, label, description, placeholder, style, wrapperConfig }) => {
    const selectedValues: Option[] = Array.isArray(input.value) ? input.value : [];
    const hasError = !!(meta.touched && meta.error);

    const onSelect = (list: Option[]) => input.onChange(list);
    const onRemove = (list: Option[]) => input.onChange(list);

    /*const baseStyle = {
        searchBox: {
            ...BOOTSTRAP_RULE(BOOTSTRAP_CONTROL, hasError),
        },
        chips: {
            background: '#e9ecef',
            color: '#495057',
            borderRadius: 3,
            marginRight: 4,
            marginTop: 4,
            marginBottom: 4,
            whiteSpace: 'wrap',
        },
    } as const;*/

    const baseStyle = {
        searchBox: {
            ...BOOTSTRAP_RULE(BOOTSTRAP_CONTROL, hasError),
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
            height: 'auto',
            minHeight: 38,
            paddingRight: 32,
            boxSizing: 'border-box',
        },
        chips: {
            background: '#f8f9fa',
            color: '#495057',
            borderRadius: 16,
            padding: '2px 8px 2px 20px',
            marginRight: 10,
            marginTop: 4,
            marginBottom: 4,
            display: 'inline-flex',
            alignItems: 'center',
            fontSize: '0.9rem',
            whiteSpace: 'wrap',
        },
    } as const;

    const composedStyle = mergeStyle(baseStyle, style);

    return (
        <FieldWrapper {...wrapperConfig} name={input.name} meta={meta}>
            {label ? <label className="control-label d-block mb-1">{label}</label> : null}
            {description ? <div className={styles.info}>{description}</div> : null}
            <Multiselect
                options={options}
                selectedValues={selectedValues}
                onSelect={onSelect}
                onRemove={onRemove}
                displayValue="label"
                customCloseIcon={<span className={styles.multiChipClose}>✕</span>}
                closeIcon="cancel"
                placeholder={placeholder || ''}
                style={composedStyle}
                emptyRecordMsg=""
                hidePlaceholder={true}
                showArrow={true}
                showCheckbox={true}
            />
        </FieldWrapper>
    );
};

function BOOTSTRAP_RULE(base: any, hasError: boolean) {
    return {
        ...base,
        border: `1px solid ${hasError ? '#dc3545' : '#ced4da'}`,
    };
}

function mergeStyle(base: any, override?: any) {
    if (!override) return base;
    const out = { ...base };
    Object.keys(override).forEach((k) => {
        out[k] = { ...(base as any)[k], ...(override as any)[k] };
    });
    return out;
}

// wrapper for redux-form
const RFField = Field as new () => GenericField<OwnProps>;
type FieldProps = BaseFieldProps<OwnProps> & OwnProps;

export const FieldMultiSelect: React.FC<FieldProps> = (props) => {
    return <RFField component={MultiSelectInput} {...props} />;
};
